import { useTranslation } from 'next-i18next';
import { Button } from '@forma/forma-ui-kit';
import { useTheme } from '@forma/forma-ui-theme';
import Link from '@/components/Link';

import styles from './document-folder.module.css';

const DocumentFolder = (props) => {
  const { t } = useTranslation();
  const { title, docs, translatedName } = props;

  const { viewport } = useTheme();
  const isPhone = viewport === 'phone';

  return (
    <>
      {docs.length !== 0 && (
        <div className={styles.root}>
          <div className={styles.titleBlock}>
            {!isPhone && <img className={styles.icon} src="/icons/explorer/folder_forma.svg" alt="" />}
            <div>{title}</div>
          </div>
          <ul>
            {docs.map(
              (elem, index) =>
                index < 4 && (
                  <li key={elem.id} className={styles.link}>
                    {isPhone && (
                      <img className={styles.icon} src="/icons/explorer/folder_forma.svg" alt="" />
                    )}
                    <Link href={`/templates/${elem.path}`}>
                      {elem.name}
                    </Link>
                  </li>
                )
            )}
          </ul>
          <Button
            size="small"
            viewStyle="tertiary"
            className={styles.button}
            as={Link}
            href={`/templates/${translatedName}`}
          >
            Еще {t('count_documents', { count: docs.length })}
          </Button>
        </div>
      )}
    </>
  );
};

export default DocumentFolder;
